<template>
  <div class="league-games-container">
    <el-row>
      <el-button type="primary" @click="goAddGame">添加比赛</el-button>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        label="场次"
        width="60"
        prop="seq">
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="180"
        prop="beginDate"
        label="比赛时间">
      </el-table-column>
      <el-table-column
        prop="homeTeam"
        label="主队">
      </el-table-column>
      <el-table-column
        prop="awayTeam"
        label="客队">
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="goGame(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDeleteGame(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { AdminGetOutGameList, AdminDeleteOutGame } from '@/api/match'

export default {
  name: 'OldLeagueGamesList',
  data() {
    return {
      list:[],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listLoading: false,
      search: {},
      matchId:null
    }
  },
  created() {
    this.matchId = this.$route.params.id
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page, 10)
    }
    this.getGameList()
  },
  computed: {},
  methods: {
    goAddGame(){
      return this.$router.push({path: `/league-old/${this.matchId}/referee-add`})
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getGameList()
    },
    goGame(row){
      return this.$router.push({path: `/league-old/${row.matchId}/referee-update/${row.id}`})
    },
    goDetails() {
      this.$router.push({ name: 'LeagueGroupGameEdit', params: { id: 1, gid: 1, mid: 1 }})
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.getGameList()
    },
    quickSearch() {
      this.getGameList()
    },
    getGameList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        matchId: this.matchId
      }
      if (this.search.beginDate) {
        this.search.beginDate = moment(this.search.beginDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      AdminGetOutGameList(this.listQuery).then((resolve) => {
        const data = resolve.data
        this.listLoading = false
        if(data) {
          this.list = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
        }
      })
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm')
    },
    handleDeleteGame(id) {
      this.$confirm('此操作将永久删除该比赛, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteGame(id)
      }).catch(() => {
      })
    },
    deleteGame(id) {
      AdminDeleteOutGame({ id: id }).then((resolve) => {
        if (resolve) {
          this.getGameList()
          this.$message({
            message: '比赛删除成功',
            type: 'success'
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .league-games-container {
    margin: 30px 15px;
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>
